import classNames from 'classnames';
import * as React from 'react';

import css from './BooksMenuMerchant.module.scss';

interface Props {
  className?: string;
  image?: string;
  nickname?: string;
  name?: string;
  url?: string;
}

const BooksMenuMerchant = ({
  className,
  image,
  nickname,
  name,
  url,
}: Props) => {
  const classes = classNames(css.BooksMenuMerchant, className);

  return (
    <div className={classes}>
      {url && (
        <a className={css.BooksMenuMerchant__Link} href={url}>
          <div className={css.BooksMenuMerchant__Inner}>
            {image ? (
              <img
                className={css.BooksMenuMerchant__Image}
                src={image}
                alt={name}
              />
            ) : (
              <span className={css.BooksMenuMerchant__Image} />
            )}
            <p className={css.BooksMenuMerchant__Name}>
              {name}
              <span className={css.BooksMenuMerchant__Id}>{nickname}</span>
            </p>
          </div>
        </a>
      )}
      {!url && (
        <div className={css.BooksMenuMerchant__Inner}>
          {image ? (
            <img
              className={css.BooksMenuMerchant__Image}
              src={image}
              alt={name}
            />
          ) : (
            <span className={css.BooksMenuMerchant__Image} />
          )}
          <p className={css.BooksMenuMerchant__Name}>
            {name}
            <span className={css.BooksMenuMerchant__Id}>{nickname}</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default BooksMenuMerchant;
